const frontEndExperiences = [
  {
    id: 1,
    name: "HTML+CSS+JS",
    level: "Academic/Work",
  },
  {
    id: 2,
    name: "WordPress",
    level: "Academic/Work",
  },
  
  {
    id: 4,
    name: "TypeScript",
    level: "Academic/Work",
  },
  {
    id: 5,
    name: "ReactJS",
    level: "Academic/Work",
  },
  {
    id: 6,
    name: "Redux",
    level: "Academic/Work",
  },
  {
    id: 7,
    name: "Vue",
    level: "Work",
  },
  {
    id: 8,
    name: "StyledComponents",
    level: "Work",
  },
  {
    id: 9,
    name: "Bootstrap",
    level: "Work",
  },
  {
    id: 10,
    name: "jQuery",
    level: "Academic",
  },
  {
    id: 11,
    name: "SASS",
    level: "Work",
  },
  {
    id: 12,
    name: "Figma",
    level: "Academic",
  },
];

const backEndExperiences = [
  {
    id: 1,
    name: "PHP",
    level: "Work",
  },
  {
    id: 2,
    name: "Laravel",
    level: "Work",
  },
  {
    id: 3,
    name: "Express/Node.js",
    level: "Academic",
  },
  {
    id: 4,
    name: "WordPress",
    level: "Work",
  },
  {
    id: 5,
    name: "MongoDB",
    level: "Academic",
  },
  {
    id: 6,
    name: "MySQL",
    level: "Academic/Work",
  },
  {
    id: 7,
    name: "Python3",
    level: "Academic",
  },
  {
    id: 8,
    name: "Django",
    level: "Academic",
  },
];

export { frontEndExperiences, backEndExperiences };
